"use strict";

exports.__esModule = true;
var _TicketDetails = require("./TicketDetails");
Object.keys(_TicketDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketDetails[key]) return;
  exports[key] = _TicketDetails[key];
});
var _StatusButtons = require("./StatusButtons");
Object.keys(_StatusButtons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StatusButtons[key]) return;
  exports[key] = _StatusButtons[key];
});
var _TicketComments = require("./TicketComments");
Object.keys(_TicketComments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketComments[key]) return;
  exports[key] = _TicketComments[key];
});
var _CreatedAtSection = require("./CreatedAtSection");
Object.keys(_CreatedAtSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreatedAtSection[key]) return;
  exports[key] = _CreatedAtSection[key];
});
var _AssigneeSection = require("./AssigneeSection");
Object.keys(_AssigneeSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AssigneeSection[key]) return;
  exports[key] = _AssigneeSection[key];
});
var _TicketDetailsEditMode = require("./TicketDetailsEditMode");
Object.keys(_TicketDetailsEditMode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketDetailsEditMode[key]) return;
  exports[key] = _TicketDetailsEditMode[key];
});
var _TicketDetailsViewMode = require("./TicketDetailsViewMode");
Object.keys(_TicketDetailsViewMode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketDetailsViewMode[key]) return;
  exports[key] = _TicketDetailsViewMode[key];
});